import { render, staticRenderFns } from "./TabLearners.vue?vue&type=template&id=8ac56874&scoped=true&"
import script from "./TabLearners.vue?vue&type=script&lang=js&"
export * from "./TabLearners.vue?vue&type=script&lang=js&"
import style0 from "./TabLearners.vue?vue&type=style&index=0&id=8ac56874&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac56874",
  null
  
)

export default component.exports